import initUpload from '../../../src/js/form/file-upload';
import { initDatepicker } from '../../../src/js/form/datepicker';

document.addEventListener('DOMContentLoaded', () => {
  initUpload();
  initDatepicker('.js-datepicker');
  const wrapper = document.querySelector('.b-partner_form');
  if (!wrapper) return;

  const typeRadios    = wrapper.querySelectorAll('.js-partner_form_type');
  const companyForm   = wrapper.querySelector('.js-partner_company_form');
  const individualForm = wrapper.querySelector('.js-partner_individual_form');

  // --- Type toggle ---
  function switchForm(type) {
    if (type === 'company') {
      companyForm?.classList.remove('m-hidden');
      individualForm?.classList.add('m-hidden');
    } else {
      individualForm?.classList.remove('m-hidden');
      companyForm?.classList.add('m-hidden');
    }
  }

  typeRadios.forEach((radio) => {
    radio.addEventListener('change', () => switchForm(radio.value));
  });

  // --- Physical address same-as-registered (Company form) ---
  const sameAddressCb    = companyForm?.querySelector('.js-pfc_same_address');
  const physicalFields   = companyForm?.querySelector('.js-pfc_physical_fields');

  if (sameAddressCb && physicalFields) {
    const togglePhysical = () => {
      const disabled = sameAddressCb.checked;
      physicalFields.classList.toggle('m-disabled', disabled);
      physicalFields.querySelectorAll('input, select').forEach((el) => {
        el.disabled = disabled;
      });
    };
    sameAddressCb.addEventListener('change', togglePhysical);
    companyForm.addEventListener('reset', () => {
      physicalFields.classList.remove('m-disabled');
      physicalFields.querySelectorAll('input, select').forEach((el) => {
        el.disabled = false;
      });
    });
  }

  // --- State field visibility based on country selection ---
  function setupStateVisibility(countrySelect, stateField) {
    if (!countrySelect || !stateField) return;
    const toggle = () => {
      stateField.classList.toggle('m-hidden', countrySelect.value !== 'United States');
    };
    countrySelect.addEventListener('change', toggle);
    toggle();
  }

  setupStateVisibility(
    companyForm?.querySelector('.js-pfc_reg_country'),
    companyForm?.querySelector('.js-pfc_reg_state_field'),
  );

  setupStateVisibility(
    individualForm?.querySelector('.js-pfi_country'),
    individualForm?.querySelector('.js-pfi_state_field'),
  );

  // --- "Other" currency text input ---
  function setupCurrencyOther(form, cbSelector, textSelector) {
    const cb   = form?.querySelector(cbSelector);
    const text = form?.querySelector(textSelector);
    if (!cb || !text) return;
    cb.addEventListener('change', () => {
      text.disabled = !cb.checked;
      if (!cb.checked) text.value = '';
    });
  }

  setupCurrencyOther(companyForm, '.js-pfc_currency_other_cb', '.js-pfc_currency_other_text');
  setupCurrencyOther(individualForm, '.js-pfi_currency_other_cb', '.js-pfi_currency_other_text');

  // --- Add Representative (Company form) ---
  const repList  = companyForm?.querySelector('.js-partner_rep_list');
  const repAddBtn = companyForm?.querySelector('.js-partner_rep_add');

  if (repList && repAddBtn) {
    repAddBtn.addEventListener('click', () => {
      const items = repList.querySelectorAll('.js-partner_rep_item');
      const idx   = items.length + 1;
      const first = items[0];
      const clone = first.cloneNode(true);

      clone.querySelector('.js-partner_rep_num').textContent = `#${idx}`;

      clone.querySelectorAll('input').forEach((input) => {
        const baseName = input.name.replace(/_\d+$/, '');
        input.name  = `${baseName}_${idx}`;
        input.value = '';
      });

      repList.appendChild(clone);

      clone.querySelectorAll('.js-datepicker').forEach((el) => initDatepicker(el));
    });
  }
});
